module.exports = __webpack_public_path__ + "static/img/4_3_1.0da37298.jpg";